import { useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import api from '@/core/services/api'
import { updateMoney } from '@/core/store/data/actions'

/** 아이콘이 너무 빨리 멈추면 눌렸는지 모른다 — 응답이 빨라도 이만큼은 돈다(ms) */
const MIN_SPIN_MS = 600

/**
 * 헤더 보유 머니만 다시 받는다(페이지 새로고침 대신).
 *   /user/profile 의 KRW.balance 는 이름과 달리 사이트 통화 잔액이다 — 헤더 SSE 의 balance[사이트 통화]와 같은 값.
 * @returns {{ spinning: boolean, refresh: function }} spinning 동안 아이콘을 돌린다
 */
export default function useRefreshMoney() {
  const dispatch = useDispatch()
  const [spinning, setSpinning] = useState(false)
  const busy = useRef(false)

  const refresh = async () => {
    if (busy.current) return
    busy.current = true
    setSpinning(true)
    const started = Date.now()
    try {
      const res = await api.get('/user/profile')
      const balance = res.data?.content?.KRW?.balance
      if (balance != null) dispatch(updateMoney(Number(balance)))
    } catch (err) {
      console.error('보유 머니 갱신 실패:', err)
    } finally {
      setTimeout(() => {
        busy.current = false
        setSpinning(false)
      }, Math.max(0, MIN_SPIN_MS - (Date.now() - started)))
    }
  }

  return { spinning, refresh }
}
